import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ListCustData } from './listCustData';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatPaginator, MatSort, MatSelect } from '@angular/material';
import { NewTicketDialogComponent } from 'src/app/modal/new-ticket-dialog/new-ticket-dialog.component';

@Component({
  selector: 'app-cdm-calling-list',
  templateUrl: './cdm-calling-list.component.html',
  styleUrls: ['./cdm-calling-list.component.scss']
})
export class CdmCallingListComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  spinner: boolean;
  callStats: any = {};
  customerData: any;
  userId: string;
  uniqueRequest = new Set<string>();
  uniqueSourceId = new Set<string>();
  selectedRequest: string[] = [];
  selectedSourceId: string[] = [];
  maxDate: Date = new Date();
  fromDate: Date = new Date();
  today: Date = new Date();
  toDate: Date = new Date();
  filteredDataSource: any;
  listSize: number = 0;
  pageSize: number;
  callFlag: any;
  callToggleStatus: boolean = true;
  dataSource: any;
  userRoles: string;

  displayedColumns: string[] = [
    'customerId',
    'customerName',
    'vin',
    'raiseDate',
    'requestStatus',
    'sourceId'
  ];
  invalidType: string;
  status: string;
  startDate: string;
  endDate: string;
  sourceId: string;
  type: string;
  userInfo: any;

  constructor(private commonService: CommonService, private router: Router, private toastr: ToastrService,
    private datePipe: DatePipe, private dialog: MatDialog) { }

  ngOnInit() {
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.customerData = JSON.parse(localStorage.getItem('customerData'));
    this.userId = localStorage.getItem('userId');
    this.userRoles = localStorage.getItem('userRoles');
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userInfo = userInfo[0];

    if (localStorage.getItem('callListPageSize') != null || localStorage.getItem('callListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('callListPageSize'));
      this.pageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
    } else {
      this.pageSize = 50;
    }

    if (localStorage.getItem('selectedRequest') != null || localStorage.getItem('selectedRequest') != undefined) {
      let selectedRequest = JSON.parse(localStorage.getItem('selectedRequest'));
      this.selectedRequest = selectedRequest;
    }

    if (localStorage.getItem('selectedSourceId') != null || localStorage.getItem('selectedSourceId') != undefined) {
      let selectedSourceId = JSON.parse(localStorage.getItem('selectedSourceId'));
      this.selectedSourceId = selectedSourceId;
    }

    // if(this.selectedSourceId.length != 0) {
    //   this.applyfilter();
    // } else {
    //   this.cdmCallList();
    // }

    this.getCDMStats();
    this.cdmCallList();
  }

  /**
    * Name: getCDMStats
    * purpose: To get stats count info
    */
   getCDMStats(): void {
    // this.spinner = true;
    this.commonService.getCDMStats(this.userId, this.userInfo.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          // this.spinner = false;
          this.callStats = res['responseData'];
        } else {
          // this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        // this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
    * Name: cdmCallList
    * purpose: To get calllist details
    * @param {string} flag - type of call
    */
   cdmCallList(): void {
    this.spinner = true;
    this.dataSource = '';
    let request = {
      invalidType : '',
      status : '',
      startDate : '',
      endDate : '',
      sourceId : '',
      type : 'fetch'
    }
    this.commonService.cdmCallList(this.userId, this.userInfo.roleId, request)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          //this.callFlag = flag;
          this.callToggleStatus = false;
          let response = res['responseData'];
          this.listSize = response.length;
          //init data table and shorting
          this.dataSource = new MatTableDataSource<ListCustData>(response);
          this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.filterData();
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
          this.callToggleStatus = true;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.callToggleStatus = true;
      });
  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('callListPageSize', size);
  }

  /**
  * Name: selectCustomer
  * purpose: To select customer for details
  * @param {Object} row - selected customer details
  */
  selectCustomer(row: ListCustData): void {
    // if(this.userRoles == 'CRE') {
    //   if(row.requestStatus == 'Open' || row.requestStatus == 'Reopen') {
        localStorage.setItem('customerId', row.customerId);
        localStorage.setItem("customerData", JSON.stringify(row));
        this.router.navigate(['cdm-customer360']);
    //   }
    // } else {
    //   if(row.requestStatus == 'Submit') {
    //     localStorage.setItem('customerId', row.customerId);
    //     localStorage.setItem("customerData", JSON.stringify(row));
    //     this.router.navigate(['cdm-customer360']);
    //   }
    // }

  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on datagrid
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /**
   * Name: filterData
   * purpose: To filter call list data
   */
  filterData(): void {
    this.dataSource.filteredData.forEach(element => {
      this.uniqueRequest.add(element.requestStatus);
      this.uniqueSourceId.add(element.sourceId);
    });

    // if ((this.selectedServiceTypeValues != null && this.selectedServiceTypeValues.length != 0)
    // || (this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0)
    // || (this.selectedCustomerTypeValues != null && this.selectedCustomerTypeValues.length != 0)
    // || (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0)) {
    //   //this.filterTriggered(null);
    //   this.applyfilter();
    // }
  }

  /**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
  applyfilter(): void {
    this.spinner = true;
    this.dataSource = '';
    let request = {
      invalidType : '',
      status : this.selectedRequest.toString(),
      startDate : this.datePipe.transform(this.fromDate, "yyyy-MM-dd"),
      endDate : this.datePipe.transform(this.toDate, "yyyy-MM-dd"),
      sourceId : this.selectedSourceId.toString(),
      type : 'filter'
    }
    this.commonService.cdmCallList(this.userId, this.userInfo.roleId, request)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          //this.callFlag = flag;
          this.callToggleStatus = false;
          let response = res['responseData'];
          this.listSize = response.length;
          //init data table and shorting
          this.dataSource = new MatTableDataSource<ListCustData>(response);
          this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.filterData();
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
          this.callToggleStatus = true;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.callToggleStatus = true;
      });
  }

  newTicket() {
    const dialogRef = this.dialog.open(NewTicketDialogComponent, {
      width: '350px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
    this.cdmCallList();
    });
  }
}
